export default "__VITE_ASSET__BJkTJMo3__"